import { combineReducers } from 'redux';
import businessIdeaNameReducer from './reducers/businessIdeaNameReducer';
import tagSelectReducer from './reducers/tagSelectReducer';
import industryReducer from './reducers/industryReducer';
import purposeReducer from './reducers/purposeReducer';
import { payloadReducer } from '@wix/branding-client-lib/dist/src/reducers/PayloadReducer';
import * as mainActionTypes from './mainActionTypes';
import suggestedNameReducer from './reducers/suggestedNameReducer';
import namesReducer from './reducers/namesReducer';
import selectedNameReducer from './reducers/selectedNameReducer';
import environmentReducer from './reducers/environmentReducer';

export function createMainReducer() {
  const appreducer = combineReducers({
    businessIdea: businessIdeaNameReducer,
    industry: industryReducer,
    tags: tagSelectReducer,
    purpose: purposeReducer,
    selectedName: selectedNameReducer,
    screenData: payloadReducer(mainActionTypes.SET_SCREEN_SIZE, {
      height: 0,
      width: 0,
      type: ''
    }),
    namesList: namesReducer,
    businessDetails: suggestedNameReducer,
    environment: environmentReducer
  });

  return (state, action) => {
    let newState = state;
    if (action.type === mainActionTypes.SET_FETCHED_INITIAL_STATE) {
      newState = { ...state, ...action.payload.state };
    }
    return appreducer(newState, action);
  };
}
